import { render, staticRenderFns } from "./RegistracijaSudionika.vue?vue&type=template&id=028c5f32&scoped=true&"
import script from "./RegistracijaSudionika.vue?vue&type=script&lang=js&"
export * from "./RegistracijaSudionika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c5f32",
  null
  
)

export default component.exports